import { DSCardWrapper } from "@components/design-system/molecules";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useLocation } from "react-router";

import { useLocalStorage } from "../../hooks";

/**
 *
 * @param {*} bannerId Hides specific banners. Examples: (None) = used to hide the small screen size banner, ExistingCustomerAutoSOAPLaunchBanner = used to hide the autosoap demo banner used to show existing customers., ...
 * @returns
 */
export function PermanentlyHideableBanner({
  children,
  bannerId = null,
  dismissButtonMxLabel = null,
}) {
  const [isPermanentlyHidden, setIsPermanentlyHidden] =
    useLocalStorage(bannerId ?? "hide-banners");

  const location = useLocation();

  const disabledRoutes = [
    "/",
    "/auth/login",
    "/auth/register",
    "/registration_confirmation",
    "/subscriptions",
  ];

  if (location && disabledRoutes.includes(location.pathname)) {
    return null;
  }

  return (
    <>
      {!isPermanentlyHidden && (
        <Banner
          setIsPermanentlyHidden={setIsPermanentlyHidden}
          dismissButtonMxLabel={dismissButtonMxLabel}
        >
          {children}
        </Banner>
      )}
    </>
  );
}

export function Banner({
  children,
  isWarning = true,
  setIsPermanentlyHidden = () => {},
  dismissButtonMxLabel = null,
}) {
  const [shouldShowBanner, setShouldShowBanner] = useState(true);
  return (
    <div
      className={
        shouldShowBanner
          ? "w-full flex items-center justify-center my-1"
          : "hidden"
      }
    >
      <DSCardWrapper variant={isWarning ? "warning" : "error"}>
        <div className="flex items-center justify-between gap-sm">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="fill-current text-primary"
          />
          <h5 className="text-center">{children}</h5>
          <button
            onClick={() => {
              setShouldShowBanner(false);
              setIsPermanentlyHidden(true);
            }}
            className="justify-self-end text-primary focus:outline-hidden transition-all cursor-pointer"
            data-mx-label={dismissButtonMxLabel}
          >
            ✖
          </button>
        </div>
      </DSCardWrapper>
    </div>
  );
}
